document.addEventListener('DOMContentLoaded', function () {
  const section = document.querySelector('.bestsellers');
  if (!section) return;
  const btns = section.querySelectorAll('[data-tab-btn]');
  const panels = section.querySelectorAll('[data-tab-panel]');
  const footerLink = section.querySelector('[data-tab-footer-link]');
  btns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      btn.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
      const idx = btn.dataset.tabBtn;
      btns.forEach(function (b) { b.classList.remove('bestsellers-tab-active'); });
      panels.forEach(function (p) { p.classList.add('is-hidden'); });
      btn.classList.add('bestsellers-tab-active');
      const panel = section.querySelector('[data-tab-panel="' + idx + '"]');
      if (panel) panel.classList.remove('is-hidden');
      if (footerLink) footerLink.href = btn.dataset.collectionUrl || '#';
    });
  });
});
